import { render } from "./automatizar.vue?vue&type=template&id=8caa63ca&scoped=true"
import script from "./automatizar.vue?vue&type=script&lang=js"
export * from "./automatizar.vue?vue&type=script&lang=js"

import "./automatizar.vue?vue&type=style&index=0&id=8caa63ca&lang=css"
import "./automatizar.vue?vue&type=style&index=1&id=8caa63ca&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8caa63ca"]])

export default __exports__